import { render } from "./App.vue?vue&type=template&id=9c0ce522"
const script = {}

import "./App.vue?vue&type=style&index=0&id=9c0ce522&lang=scss"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.40_vue@3.5.40_typescript@4.9.5__webpack@5.108.4_cssna_qgrzoppke2v4swfvs2n2a5wpv4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__